export var languages = {
  en: {
    short: 'EN',
    full: 'English',
    uploadcare: 'en',
    enabled: true
  },
  'es-LA': {
    short: 'ES',
    full: 'Spanish',
    uploadcare: 'es',
    enabled: false
  },
  es: {
    short: 'ES',
    full: 'Spanish',
    uploadcare: 'es',
    enabled: true
  },
  'pt-BR': {
    short: 'PT',
    full: 'Portuguese',
    uploadcare: 'pt',
    enabled: true
  },
  pt: {
    short: 'PT',
    full: 'Portuguese',
    uploadcare: 'pt',
    enabled: false
  }
};